import React from "react";
import type {ReactNode} from "react";
import {useAuth} from "../auth";
import {routePath} from "../auth/roles";
import {useRoute} from "../hooks";
import {Logo} from "./Logo";

const MERCHANT_NAV_ITEMS = [
  {path: "#/merchant", label: "Обзор", exact: true},
  {path: "#/merchant/orders", label: "Заявки", exact: false},
  {path: "#/merchant/balance", label: "Баланс", exact: true},
  {path: "#/merchant/withdrawals", label: "Вывод USDT", exact: true},
] as const;

interface MerchantLayoutProps {
  children: ReactNode;
}

export function MerchantLayout({children}: MerchantLayoutProps): JSX.Element {
  const {user, logout} = useAuth();
  const route = useRoute();
  const path = routePath(route);

  return (
    <div className="app-layout merchant-layout">
      <aside className="sidebar merchant-sidebar">
        <a className="sidebar-brand merchant-brand" href="#/merchant">
          <Logo size={24}/>
          <span>Кабинет мерчанта</span>
        </a>
        <nav className="sidebar-nav merchant-nav" aria-label="Разделы кабинета">
          {MERCHANT_NAV_ITEMS.map((item) => {
            const active = item.exact
              ? path === item.path || (item.path === "#/merchant" && path === "#/merchant/")
              : path === item.path || path.startsWith(`${item.path}/`);
            return (
              <a
                key={item.path}
                href={item.path}
                className={`nav-item ${active ? "active" : ""}`}
                aria-current={active ? "page" : undefined}
              >
                {item.label}
              </a>
            );
          })}
        </nav>
        <div className="sidebar-footer merchant-sidebar-footer">
          <a
            className={`user-info user-info-link ${path === "#/merchant/settings" ? "active" : ""}`}
            href="#/merchant/settings"
            aria-current={path === "#/merchant/settings" ? "page" : undefined}
          >
            <div className="user-avatar">
              {(user?.login || "M")[0].toUpperCase()}
            </div>
            <div className="user-meta">
              <span className="user-name">{user?.login || "—"}</span>
              <span className="user-role">Мерчант</span>
              <span className="user-settings">Настройки</span>
            </div>
          </a>
          <button className="btn btn-ghost btn-sm" type="button" onClick={logout}>
            Выйти
          </button>
        </div>
      </aside>
      <main className="main-content merchant-main">{children}</main>
    </div>
  );
}
